import React, { useEffect } from "react";
import "./Support.css";
import { Accordion, Button, Form, Table } from "react-bootstrap";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import { allFaq } from "../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Create } from "../../../../../features/admin/student/ticketraised/Slice";
import classNames from "classnames";
import { useForm } from "react-hook-form";

function Support() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const faqs = useSelector((state) => state.common.all_faq);
  console.log(faqs, "faqsfaqs");

  useEffect(() => {
    dispatch(allFaq());
  }, [dispatch]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        name: data.name,
        contact_no: data.contact_no,
        subject: data.subject,
        description: data.description,
      };

      const res = await dispatch(Create(payload));

      if (res.meta?.requestStatus === "fulfilled") {
        reset();
        // optional success toast / modal
        console.log("Ticket created successfully");
      } else if (res.meta?.requestStatus === "rejected") {
        console.error(res.payload);
      }
    } catch (error) {
      console.error("Ticket submit error", error);
    }
  };

  const ticketHistory = [
    {
      ticket_id: "Garde Manger",
      subject: "Payment not reflected",
      status: "Under Review",
      date: "12 Oct 2025",
    },
    {
      ticket_id: "Sous Chef",
      subject: "Document verification",
      status: "Accepted",
      date: "24 Oct 2025",
    },
    {
      ticket_id: "Saucier (Sauce Chef)",
      subject: "Payment not reflected",
      status: "Refused",
      date: "01 Nov 2025",
    },
    {
      ticket_id: "Student Advisor",
      subject: "Document verification",
      status: "Payment Due",
      date: "06 Nov 2025",
    },

    {
      ticket_id: "Garde Manger",
      subject: "Payment not reflected",
      status: "Under Review",
      date: "12 Oct 2025",
    },
    {
      ticket_id: "Sous Chef",
      subject: "Document verification",
      status: "Accepted",
      date: "24 Oct 2025",
    },
    {
      ticket_id: "Saucier (Sauce Chef)",
      subject: "Payment not reflected",
      status: "Refused",
      date: "01 Nov 2025",
    },
    {
      ticket_id: "Student Advisor",
      subject: "Document verification",
      status: "Payment Due",
      date: "06 Nov 2025",
    },

    {
      ticket_id: "Garde Manger",
      subject: "Payment not reflected",
      status: "Under Review",
      date: "12 Oct 2025",
    },
    {
      ticket_id: "Sous Chef",
      subject: "Document verification",
      status: "Accepted",
      date: "24 Oct 2025",
    },
    {
      ticket_id: "Saucier (Sauce Chef)",
      subject: "Payment not reflected",
      status: "Refused",
      date: "01 Nov 2025",
    },
    {
      ticket_id: "Student Advisor",
      subject: "Document verification",
      status: "Payment Due",
      date: "06 Nov 2025",
    },
  ];

  const statusClass = {
    "Under Review": "under-review",
    Accepted: "accepted",
    Refused: "refused",
    "Payment Due": "payment-due",
  };
  return (
    <section className="Support">
      <div className="Faq_accordians_holder Support_form_holder">
        <div className="form_holder">
          <Form>
            <Accordion defaultActiveKey="0">
              {faqs && faqs.length > 0 ? (
                faqs
                  .filter((faq) => faq.status === true) // optional: show only active FAQs
                  .map((faq, index) => (
                    <Accordion.Item eventKey={String(index)} key={faq.id}>
                      <Accordion.Header>{faq.question}</Accordion.Header>

                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                  ))
              ) : (
                <p className="text-center mt-3">No FAQs available</p>
              )}
            </Accordion>
          </Form>
        </div>
      </div>

      <div className="Support_form_holder">
        <div className="heading_text_holder">
          <h1>Raise a Ticket</h1>
        </div>
        <div className=" card_box">
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <Form.Group className="form_field  ">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 100,
                          message: "Name cannot exceed 100 characters",
                        },
                        pattern: {
                          value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                          message:
                            "Name should contain only letters and single spaces (no leading or trailing spaces)",
                        },
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6 mb-3">
                  <Form.Group className="form_field  ">
                    <Form.Label>Contact Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Contact Number"
                      className={classNames("", {
                        "is-invalid": errors?.contact_no,
                      })}
                      {...register("contact_no", {
                        required: "Contact number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Enter a valid 10-digit contact number",
                        },
                      })}
                    />
                    {errors?.contact_no && (
                      <Form.Text className="text-danger">
                        {errors.contact_no.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-12 mb-3">
                  <Form.Group className="form_field ">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Type your Description here"
                      className={classNames("", {
                        "is-invalid": errors?.description,
                      })}
                      {...register("description", {
                        required: "Description is required",
                      })}
                    />
                    {errors?.description && (
                      <Form.Text className="text-danger">
                        {errors.description.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-12 mb-3">
                  <Form.Group className="form_field ">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Subject"
                      className={classNames("", {
                        "is-invalid": errors?.subject,
                      })}
                      {...register("subject", {
                        required: "Subject is required",
                        maxLength: {
                          value: 150,
                          message: "Subject cannot exceed 150 characters",
                        },
                      })}
                    />
                    {errors?.subject && (
                      <Form.Text className="text-danger">
                        {errors.subject.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <Blue_border_button button_text="Submit Ticket" type="submit" />
            </Form>
          </div>
        </div>
      </div>

      <div className="Support_form_holder">
        <div className="heading_text_holder">
          <h1>Ticket History</h1>
        </div>
        <div className=" card_box">
          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Program Name</th>
                  <th>Status</th>
                  <th>Last Update</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {ticketHistory.map((app, index) => (
                  <tr key={index}>
                    <td>{app.ticket_id}</td>
                    <td>{app.subject}</td>

                    <td>
                      <span
                        className={`status-badge ${statusClass[app.status]}`}
                      >
                        {app.status}
                      </span>
                    </td>

                    <td>{app.date}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Support;
